import { createSelector } from 'reselect';

export const getSocketEventsAccesor = state => state.shared.socketEvents;

export const socketEventsSelector = createSelector(getSocketEventsAccesor, socketEvents => socketEvents);
